import { Assistants } from '@local/client-contracts';
import { SourceSettings } from '../source-settings';
import { AnswerSearchItem } from 'src/app/bar/views';

export interface TranslateTicketSourceSettings {
  request: Assistants.TicketTranslateRequest;
  answerItem: AnswerSearchItem;
}

export interface AssistantIncontextSourceSettings extends SourceSettings {
  type: 'assistant-incontext';
  requestMaxCount: number;
  localOnly?: boolean;
  contentSearch?: boolean;
  advancedSearch?: boolean;
  useSourceFilters?: boolean;
  sessionId?: string;
  data: Assistants.AssistantTicketRequest;
  translateData?: TranslateTicketSourceSettings;
}
